import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { SET_TEXT, SET_IMAGE, RESET_COMPOSER } from '../../Actions/Composer'
import { SendIcon, PlusIcon, CloseIcon } from '../../Svg/Index.js'

class Composer extends Component {
    state = {
        text: '',
        image: null,
        imageUploading: false,
    }

    handleTextChange = (text) => {
        this.props.actions.SET_TEXT(this.refs.composer_text.value)
    }

    handleComposerSubmit = (e, trigger) => {
        if(e.key === 'Enter' || e.currentTarget.classList.contains('js-composer-submit')){
            this.props.handleSend();
            this.props.actions.RESET_COMPOSER();
            this.refs.composer_text.value = '';
            this.setState({
                imageUploading: false
            });
        }
    }

    handleFileUpload = () => {
        let input = this.refs.composer_file;
        this.setState({
            imageUploading: true
        });

        if (input.files && input.files[0]) {
            let reader = new FileReader();
            reader.onload = (image)=> {
                this.refs.composer_image_preview.style.backgroundImage = `url('${image.target.result}')`;
                this.props.actions.SET_IMAGE(input.files[0])
            }
            reader.readAsDataURL(input.files[0]);
        }

    }

    cancelImageUpload = () => {
        this.props.actions.SET_IMAGE(null)
        this.setState({
            imageUploading: false
        });
    }

    render() {
        const { imageUploading } = this.state
        return (
            <>
                <div className="c-composer">
                    <div className="c-composer__inner">
                        <div className="c-composer__add">
                            <label className="c-bare-btn" htmlFor="composer_file">
                                <PlusIcon />
                                <input type="file" accept="image/x-png,image/jpeg" id="composer_file" name="composer_file" ref="composer_file" onChange={this.handleFileUpload} className="u-hidden" />
                            </label>
                        </div>
                        <div className="c-composer__input">
                            <input type="text" onChange={this.handleTextChange} ref="composer_text" onKeyPress={this.handleComposerSubmit}/>
                            {
                                imageUploading && (
                                    <div className="c-image-upload">
                                        <div className="c-image-upload__media" ref="composer_image_preview">
                                            <button className="c-btn c-image-upload__cancel" onClick={this.cancelImageUpload}>
                                                <CloseIcon />
                                            </button>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className="c-composer__send">
                            <button className="c-btn js-composer-submit" onClick={this.handleComposerSubmit}>
                                <SendIcon />
                            </button>
                        </div>
                    </div>
                </div>
                
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        composer: state.composer.composer
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_TEXT, SET_IMAGE, RESET_COMPOSER}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Composer)